import { useValidateIsTrue } from "formvalidation/hooks";
import React from "react";
import { Checkbox } from "../../components/Atoms/inputs/Checkbox";

interface Props {
  upgradeMessage: string
}

export const UpgradeConfirmation = (props: Props) => {
  const [hasConfirmed, setHasConfirmed] = React.useState<boolean>(false);

  const validation = useValidateIsTrue({
    key: "confirmUpgrade",
    title: RESX.Subscription.Upgrade,
    value: hasConfirmed,
  });

  return <div className="main-section-template-fields-padding">
    <div className="flex-column gap-small">
      <div>
        <Checkbox error={validation.error.hasError} checked={hasConfirmed} onChange={() => { setHasConfirmed(!hasConfirmed); }} label={RESX.Buttons.btnIAgree} />
      </div>

      <div className="text-sublabel" dangerouslySetInnerHTML={{ __html: props.upgradeMessage.split("\n").join("<br/>") }} />
    </div>
  </div>
}
